// Keyboard movement in the module dropdown's menu (WAI-ARIA menu button pattern), pure
// so it can be tested without a DOM. Enter/Space/Escape are handled by the component.
export function nextMenuIndex(key, index, count) {
  if (count === 0) return null;
  switch (key) {
    case 'ArrowDown': return (index + 1) % count;
    case 'ArrowUp': return (index - 1 + count) % count;
    case 'Home': return 0;
    case 'End': return count - 1;
    default: return null;
  }
}
